import RouteErrorElement from "@app/layouts/ErrorLayout/RouteErrorElement";
import AboutsUs from "@pages/AboutUs/AboutUs";
import Tag from "@pages/Tag/Tag";
import { fetchContext } from "@sphtech/web2-core/ssr";
import { RouteObject } from "react-router";

import VideoLandingPage from "./VideoLandingPage";

const errorElement = import.meta.env.PROD ? <RouteErrorElement /> : undefined;

/**
 * Routes specific to HW
 */
export const pubRoutes: RouteObject[] = [
  {
    path: "/video",
    element: <VideoLandingPage />,
    errorElement,
    loader: fetchContext,
  },
  {
    path: "/about-us",
    element: <AboutsUs />,
    errorElement,
    loader: fetchContext,
  },
  {
    path: "/events",
    element: <Tag />,
    errorElement,
    loader: fetchContext,
  },
];
